import styled from 'styled-components';
import { ModalFooter } from 'react-bootstrap';

export const CustomTemplateAddEditModalFooterStyled = styled(ModalFooter)`
  & > .btn-danger {
    float: left;
  }
`;
